
import { RequestListController } from '../controllers/requestListController';

import '../services/requestListService';
import '../../../../core/directives/itemsList/itemsListDirective';
import '../../../../core/directives/searchBar/searchBarDirective';
import '../../../../core/directives/filterbar/filterbarcomponent';
import '../../../../core/featureroles/featureDisabledFor';

export class RequestListDirective implements angular.IDirective {
    controller = RequestListController;
    controllerAs = 'vm';
    restrict = 'E';
    template = require('../templates/requestList.html');
    replace = true;
    scope: {};

    static factory(): angular.IDirectiveFactory {
        return () => new RequestListDirective();
    }
}

angular.module('deliveryCreate.app').directive('requestList', RequestListDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/directives/requestListDirective.ts
 **/